<script>
  import solicitacaoImportacaoServico from '../servico.js';
  import ListaItens from './compartilhado/FormListaItens.vue';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import Barcode from '@xkeshi/vue-barcode';

  export default {
    components: { ListaItens, Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
      }
    },
    methods: {
      codigoImportacao(idSolicitacaoImportacao) {
        return 'MI-' + idSolicitacaoImportacao;
      },
      carregar: function(id) {
        this.carregando = true;

        solicitacaoImportacaoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          })
          .catch(erro => {
            let msg = erro.message;           
          });

      },
    },
    computed: {

    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Importação - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-importacao';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação de Importação - Relatório'"></cabecalho>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ codigoImportacao(solicitacao.idSolicitacaoImportacao) || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.pedidoPor ? solicitacao.pedidoPor.nomePessoaFisicaJuridica : '---'  }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Nome contato</dt>
                    <dd>{{ solicitacao.nomeSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Email contato</dt>
                    <dd>{{ solicitacao.emailSolicitante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Telefone contato</dt>
                    <dd>{{ solicitacao.telefoneSolicitante || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.protocolo ? solicitacao.protocolo.numeroProtocolo : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Financiador</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Data aprovação</dt>
                    <dd>{{ solicitacao.dataAprovacao }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número processo</dt>
                    <dd>{{ solicitacao.numeroProcesso || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Descrição da Importação aprovada  junto ao Financiador</dt>
                    <dd>{{ solicitacao.descricaoImportacaoFinanciador || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Título do projeto</dt>
                    <dd>{{ solicitacao.tituloProjeto || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Objetivo do projeto</dt>
                    <dd>{{ solicitacao.objetivoProjeto || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Área</dt>
                    <dd>{{ solicitacao.area || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Sub área</dt>
                    <dd>{{ solicitacao.subArea || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Instituição sede</dt>
                    <dd>{{ solicitacao.instituicaoSede || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>CNPJ Executora</dt>
                    <dd>{{ solicitacao.cnpjExecutora || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>Credenciamento CNPQ</dt>
                    <dd>{{ solicitacao.credenciamentoCNPQ || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados Local de Entrega e de doação de Bens e Equipamentos</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>CEP</dt>
                    <dd>{{ solicitacao.cepLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.enderecoLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.numeroLocalAlocado || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-2">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.complementoLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.bairroLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidadeLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Estado</dt>
                    <dd>{{ solicitacao.estadoLocalAlocado || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Unidade</dt>
                    <dd>{{ solicitacao.unidadeLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>CNPJ Unidade</dt>
                    <dd>{{ solicitacao.cnpjUnidadeLocalAlocado || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Representante no Brasil</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Nome empresa</dt>
                    <dd>{{ solicitacao.nomeEmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Contato empresa</dt>
                    <dd>{{ solicitacao.contatoEmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Email</dt>
                    <dd>{{ solicitacao.emailEmpresaInvoice || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Site</dt>
                    <dd>{{ solicitacao.siteEmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 1</dt>
                    <dd>{{ solicitacao.telefone1EmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 2</dt>
                    <dd>{{ solicitacao.telefone2EmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>País</dt>
                    <dd>{{ solicitacao.paisEmpresaInvoice || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados do Exportador</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-9">
                    <dt>Nome exportador</dt>
                    <dd>{{ solicitacao.nomeExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Email</dt>
                    <dd>{{ solicitacao.emailExportador || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Site</dt>
                    <dd>{{ solicitacao.siteExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 1</dt>
                    <dd>{{ solicitacao.telefone1Exportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 2</dt>
                    <dd>{{ solicitacao.telefone2exportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>País</dt>
                    <dd>{{ solicitacao.paisExportador || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.enderecoExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>ZIP Code</dt>
                    <dd>{{ solicitacao.zipCodeExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.cidadeExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Estado</dt>
                    <dd>{{ solicitacao.estadoExportador || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados Bancários Exportador</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Instituição Financeira</dt>
                    <dd>{{ solicitacao.instituicaoFinanceira || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>Endereço da Agência</dt>
                    <dd>{{ solicitacao.enderecoAgencia || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número Agência</dt>
                    <dd>{{ solicitacao.numeroAgencia || '---' }}</dd>
                  </dl>
                </div>


                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número da Conta</dt>
                    <dd>{{ solicitacao.numeroConta || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>IBAN</dt>
                    <dd>{{ solicitacao.iban || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>SWFIT Code</dt>
                    <dd>{{ solicitacao.swfitCode || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Informações Complementares</dt>
                    <dd>{{ solicitacao.informacoesComplementares || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Números de Controle</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Data da Proforma</dt>
                    <dd>{{ solicitacao.dataProforma || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>N° Proforma Invoice</dt>
                    <dd>{{ solicitacao.numeroProformaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Validade Proposta</dt>
                    <dd>{{ solicitacao.validadeProposta || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Data NR</dt>
                    <dd>{{ solicitacao.dataNR || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-9">
                    <dt>Nossa Referência</dt>
                    <dd>{{ solicitacao.nossaReferencia || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Condições Gerais das compras (INCOTERMS)</h3>
                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Forma Pagamento</dt>
                    <dd>{{ solicitacao.importacaoFormaPagamento ? solicitacao.importacaoFormaPagamento.formaPagamento : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Previsão de Entrega</dt>
                    <dd>{{ solicitacao.importacaoPrevisaoEntrega ? solicitacao.importacaoPrevisaoEntrega.previsaoEntrega : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>INCOTERM</dt>
                    <dd>{{ solicitacao.importacaoIncoterm ? solicitacao.importacaoIncoterm.incoterm : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Moeda</dt>
                    <dd>{{ solicitacao.importacaoMoeda ? solicitacao.importacaoMoeda.nomeMoeda : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Tipo Embarque</dt>
                    <dd>{{ solicitacao.importacaoTipoEmbarque ? solicitacao.importacaoTipoEmbarque.tipoEmbarque : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Destino Carga</dt>
                    <dd>{{ solicitacao.importacaoDestinoCarga ? solicitacao.importacaoDestinoCarga.destinoCarga : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Banco de Débito</dt>
                    <dd>{{ solicitacao.banco ? solicitacao.banco.nome + ' ' + solicitacao.banco.numero  : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Agência de Débito</dt>
                    <dd>{{ solicitacao.agencia ? solicitacao.agencia.numero : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Conta de Débito</dt>
                    <dd>{{ solicitacao.conta ? solicitacao.conta.nome : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Outras Condições Gerais das Compras (INCOTERMS)</dt>
                    <dd>{{ solicitacao.outrasCondicoesCompra || '---' }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Observação da Solicitação/Detalhes</dt>
                    <dd>{{ solicitacao.observacaoSolicitacao || '---' }}</dd>
                  </dl>
                </div>

                <lista-itens :itens-solicitacao-importacao="solicitacao.itensSolicitacaoImportacao" :relatorio="true"></lista-itens>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao/componentes/SolicitacaoImportacaoRelatorio.vue